/* euroguard · Guardia del carrito para las ofertas ligadas a una suscripción.
   Se carga en la página del carrito (sections/eg-main-cart.liquid).
   · Filtro de grifo: si el cliente elimina los cartuchos con suscripción, el filtro gratis (0 €) asociado
     se retira también, y nunca puede tener cantidad > 1.
   · Bajo encimera: el sistema a precio de suscriptor (_offer_requires_sub) se retira si desaparece el
     cartucho con plan de venta del mismo grupo, y se limita a 1 unidad.
   Complementa (no sustituye) una validación de checkout del lado del servidor. */
(async () => {
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    const sources = ['eg-pdp-faucet', 'eg-pdp-undersink'];
    const groups = {};
    cart.items.forEach((item, i) => {
      const p = item.properties || {};
      if (!sources.includes(p._offer_source) || !p._offer_group) return;
      const g = groups[p._offer_group] || (groups[p._offer_group] = { main: [], addon: [] });
      g[p._offer_role === 'addon' ? 'addon' : 'main'].push({ item, line: i + 1 });
    });
    const changes = [];
    Object.values(groups).forEach(g => {
      const hasSub = g.addon.some(a => a.item.selling_plan_allocation && a.item.quantity > 0);
      g.main.forEach(m => {
        const p = m.item.properties || {};
        const free = m.item.final_line_price === 0 || m.item.original_price === 0;
        const tied = free || String(p._offer_requires_sub || '') === '1';
        if (tied && !hasSub) changes.push({ line: m.line, quantity: 0 });
        else if (tied && m.item.quantity > 1) changes.push({ line: m.line, quantity: 1 });
      });
    });
    if (!changes.length) return;
    for (const c of changes.sort((a, b) => b.line - a.line)) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(c) });
    }
    location.reload();
  } catch (e) { console.warn('eg-offer-guard', e); }
})();
